import { useAuth } from '@dc-shared-web/providers/AuthProvider'
import { useGetOfficeDocumentTypes } from '@/dc-shared-web/src/hooks/api/office/useGetOfficeDocumentTypes'
import { useGetDocumentTypesByOffice } from '@/dc-shared-web/src/hooks/api/office/useGetDocumentTypesByOffice'

export const useGetDocumentTypes = () => {
  const { user } = useAuth()

  const { data: allDocumentTypes } = useGetOfficeDocumentTypes({
    enabled: user.is_super_admin,
  })
  const { data: officeDocumentTypes } = useGetDocumentTypesByOffice({
    officeUUID: !user.is_super_admin ? user._currOfficeUUID : undefined,
  })

  /* Non-SA users should use office-specific document types */
  const remoteDocumentTypes = user.is_super_admin
    ? allDocumentTypes
    : officeDocumentTypes

  return remoteDocumentTypes
}
